import React, { useRef } from 'react';

import CopyButton from './CopyButton';

function EmailSignature({
    headerText,
    value,
    isLoading,
}) {
    const paragraphRef = useRef(null);

    const handleCopy = () => {
        const paragraph = paragraphRef.current;

        const range = document.createRange();
        range.selectNode(paragraph);

        const selection = window.getSelection();
        selection.removeAllRanges();
        selection.addRange(range);

        try {
            document.execCommand('copy');
        } catch (err) {
            // eslint-disable-next-line no-console
            console.error('Unable to copy text: ', err);
        } finally {
            selection.removeAllRanges();
        }
    };

    return (
        <div className="bg-cirrusWhite mt-5 sm:mt-0 mx-0 dm:mx-5 py-4 sm:py-8 px-2 sm:px-4 rounded-lg border border-gray-200 shadow-md flex flex-col gap-2">
            <div className="block sm:flex flex-wrap w-full justify-between items-center">
                <p className="text-cleanSlate font-instrument text-base font-semibold leading-6 pb-2">{headerText}</p>
                <div className="flex gap-3">
                    <CopyButton disabled={isLoading} onClick={handleCopy} />
                </div>
            </div>
            <div>
                { /* eslint-disable-next-line react/no-danger */}
                <div ref={paragraphRef} className="text-sm text-cleanSlate" dangerouslySetInnerHTML={{ __html: value }} />
            </div>
        </div>
    );
}

export default EmailSignature;
